export function truncateFileName(imageName: string, maxLength: number) {
  if (imageName.length <= maxLength) {
    return imageName; // Keine Verkürzung erforderlich
  }

  const fileExtension = imageName.split('.').pop() ?? ''; // Dateierweiterung extrahieren
  const fileNameWithoutExtension = imageName.slice(
    0,
    imageName.length - fileExtension.length - 1
  );
  const truncatedFileName = `${fileNameWithoutExtension.slice(
    0,
    maxLength / 2 - 2
  )}...${fileNameWithoutExtension.slice(-maxLength / 2 + 1)}.${fileExtension}`;

  return truncatedFileName;
}
